import { createRoot } from 'react-dom/client';

import App from './App';

import 'twyne-new.ui/style.css';
import '@/globals.css';

const container = document.getElementById('root')
const root = createRoot(container);
root.render(<>
  <App />
</>);
